import { toast } from "react-toastify";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Swal from "sweetalert2";
import { CRYPTO_IV, CRYPTO_KEY, OTHER_PATH, SWEET_ALERT_CANCEL_COLOR, SWEET_ALERT_OK_COLOR } from "../app.config";
import Cookies from "js-cookie";
import CryptoJS from 'crypto-js';
import ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const KEY = CryptoJS.enc.Utf8.parse("Ewgmi98zL9YTROlTRRtanaw5g6g8eucp");
const IV = CryptoJS.enc.Utf8.parse("Ewgmi98zL9YTROlT");




export const Encryption = (request = {}, isStringify) => {
  //console.log('request :', request);
  const requestData = isStringify ? JSON.stringify(request) : request;
  let encrypted = CryptoJS.AES.encrypt(requestData, KEY, { iv: IV }).toString();
  return encrypted
}

export const Decryption = async (response) => {
   //console.log('Decreption response', response);
  let decrypted = await CryptoJS.AES.decrypt(response.toString(), KEY, { iv: IV });
  let decryptedData = await JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  // console.log("//////////////////////////////////",decrypted);
  
  return decryptedData;
}


export const DecryptPassword = async (encryptedText) => {
  try {
   
    const decrypted = CryptoJS.AES.decrypt(encryptedText, KEY, { iv: IV });
    
    
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    
    //console.log("Decrypted data is:", decryptedString);
    return decryptedString;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

const capitalizeWords = (str) => {
  const hyphenIndex = str.indexOf("-");
  if (hyphenIndex !== -1) {
    const words = str.split("-");
    const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
    return capitalizedWords.join(" ");
  } else {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
};

const convertToPNG = async (blob) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((pngBlob) => {
        resolve(pngBlob);
      }, "image/png");
    };

    img.onerror = reject;
    img.src = URL.createObjectURL(blob);
  });
};


const inputHandlerMaxLength = (e) => {
  const { value, maxLength } = e.target;
  if (String(value).length >= maxLength) {
    e.preventDefault();
    return;
  }
};

const validateLessThanMax = (min, max, errMsg) => {
  return min <= max || errMsg;
};

const isActive = (status) => {
  return status ? "Active" : "Inactive";
};

const formatDate = (date, format) => {
  return dayjs(date).format(format);
};

const formatDateLocalToUtc = (date, format) => {
  const localTime = dayjs(date);
  const localOffset = localTime.utcOffset();
  return localTime.subtract(localOffset, 'minute').format(format);
};

const convert12hrTo24hr = (time) => {
  dayjs.extend(customParseFormat);
  return dayjs(time, "h:mm A").format("HH:mm");
};

const convert24hrTo12hr = (time) => {
  dayjs.extend(customParseFormat);
  return dayjs(time, "HH:mm").format("h:mm A");
};

const convertToBase64 = async (file) => {
  if (file.type.includes("video")) return URL.createObjectURL(file);
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = reject;
    file && fileReader.readAsDataURL(file);
  });
};

export const loginRedirection = (data) => {
  Cookies.set('isLoginCA', true, { expires: 2 });
  Cookies.set('tokenCA', Encryption(data.token), { expires: 2 });
  Cookies.set('dataCA', JSON.stringify({ ...data, token: '' }), { expires: 2 });
}

export const logoutRedirection = () => {
  Cookies.remove('isLoginCA');
  Cookies.remove('dataCA');
  Cookies.remove('tokenCA');
  localStorage.removeItem("credential");
  let path = window.location.protocol + "//" + window.location.host + "/" + OTHER_PATH + "login"
  window.location.href = path;
}

const SWIT_SUCCESS = (message) => {
  return Swal.fire({
    position: 'top-center',
    icon: 'success',
    title: message,
    showConfirmButton: false,
    timer: 1800
  })
};

const SWIT_DELETE = (message, button) => {
  return Swal.fire({
    title: 'Are you sure?',
    text: message ? message : "You won't be able to delete this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: SWEET_ALERT_CANCEL_COLOR,
    cancelButtonColor: SWEET_ALERT_OK_COLOR,
    confirmButtonText: button ? button : 'Yes, delete it!'
  })
};

const SWIT_LOGOUT = (message, button) => {
  return Swal.fire({
    title: 'Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: SWEET_ALERT_CANCEL_COLOR,
    cancelButtonColor: SWEET_ALERT_OK_COLOR,
    confirmButtonText: button ? button : 'Yes,Log out!'
  })
};

const SWIT_DELETE_SUCCESS = (message) => {
  return Swal.fire({
    position: 'top-center',
    icon: 'success',
    title: message ? message : 'Your data has been deleted.',
    showConfirmButton: false,
    timer: 1500
  })
};

const TOAST_SUCCESS = (message) => {
  return toast.success(message);
};

const TOAST_INFO = (message) => {
  return toast.info(message);
};

const TOAST_ERROR = (message) => {
  return toast.error(message);
};

const TOAST_WARNING = (message) => {
  return toast.warning(message);
};

const MOBILE_VALIDATION = () => {
  return ({ required: "Please enter mobile number", pattern: { value: /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i, message: "Please enter valid mobile number", }, maxLength: { value: 10, message: "Mobile number should not exceed 10 characters" }, minLength: { value: 8, message: "Please enter atleast 8 digits for mobile number" } })
};

const EMAIL_VALIDATION = () => {
  return ({ required: "Please enter email address", pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Please enter valid email address", }, })
};

const PASSWORD_VALIDATION = (fieldName = 'password') => {
  return ({ required: `Please enter ${fieldName}`, pattern: { value: /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, message: `${capitalizeWords(fieldName)} must contain at least 8 characters, one uppercase, one number and one special case character`, }, })
};

const CONFIRM_PASSWORD_VALIDATION = (value) => {
  return ({ required: "Please enter confirm password", pattern: { value: /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, message: "Confirm password must contain at least 8 characters, one uppercase, one number and one special case character", }, validate: (v) => v === value || "Password do not match" })
};

const NUMBER_VALIDATION = (fieldName) => {
  return ({
    required: "Please enter " + fieldName,
    minLength: {
      value: 1,
      message: `Invalid ${fieldName}.`
    },
    pattern: {
      value: /^[0-9.]+$/,
      message: `${capitalizeWords(fieldName)} should only Positive numbers`
    }
  })
};

const TEXT_VALIDATION = (fieldName) => {
  return ({
    required: "Please enter " + fieldName,
    minLength: {
      value: 2,
      message: `Invalid ${fieldName}.`
    },
    pattern: {
      value: /^[A-Za-z]+$/,
      message: `${capitalizeWords(fieldName)} should only contain letters`
    }
  })
};

const TEXT_WITH_SPACE_VALIDATION = (fieldName) => {
  return ({
    required: "Please enter " + fieldName,
    minLength: {
      value: 2,
      message: `Invalid ${fieldName}.`
    },
    pattern: {
      value: /^[A-Za-z ]+$/,
      message: `${capitalizeWords(fieldName)} should only contain letters`
    }
  })
};


const TEXT_WITH_NOT_START_SPACE_VALIDATION = (fieldName) => {
  return ({
    required: "Please enter " + fieldName,
    minLength: {
      value: 2,
      message: `Invalid ${fieldName}.`
    },
    pattern: {
      value: /^(?!\s).*/,
      message: `${capitalizeWords(fieldName)} should only contain letters`
    }
  })
};


const TEXT_NUMBERS_VALIDATION = (fieldName) => {
  return ({
    required: "Please enter " + fieldName,
    minLength: {
      value: 2,
      message: `Invalid ${fieldName}.`
    },
    pattern: {
      value: /^[A-Za-z0-9 ]+$/,
      message: `${capitalizeWords(fieldName)} should only contain letters and numbers`
    }
  })
};

const TEXTAEREA_NUMBERS_VALIDATION = (fieldName, max = 200) => {
  return ({
    required: "Please enter " + fieldName,
    minLength: {
      value: 2,
      message: `Invalid ${fieldName}.`
    },
    pattern: {
      value: /^[\nA-Za-z0-9 .',"/$@#!&(){}*:;-]+$/,
      message: `${capitalizeWords(fieldName)} should only contain letters and numbers`
    },
    maxLength: {
      value: max,
      message: `Maximum ${fieldName} message length reached`
    },
  })
};

const isOnlyNumber = (evt) => {
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    evt.preventDefault();
    return
  }
};

const isOnlyNumberMaxLength = (evt) => {
  evt = (evt) ? evt : window.event;
  const { value, maxLength } = evt.target;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && value.length >= maxLength) {
    evt.preventDefault();
    return
  }
};

// const ExportToCSV = (data, fileName) => {
//   try {
//     let csvContent = '';
//     if (Array.isArray(data) && data.length > 0) {
//       if (Array.isArray(data[0])) {
//         csvContent = data.map(row => row.join(",")).join("\n");
//       } else if (typeof data[0] === 'object') {
//         const headers = Object.keys(data[0]);
//         csvContent += headers.join(",") + "\n";
//         csvContent += data.map(row =>
//           headers.map(header => row[header]).join(",")
//         ).join("\n");
//       }
//     }
//     const blob = new Blob([csvContent], { type: 'text/csv' });

//     if (window.navigator.msSaveBlob) {
//       window.navigator.msSaveBlob(blob, `${fileName}.csv`);
//     } else {
//       const link = document.createElement("a");
//       if (link.download !== undefined) {
//         const url = URL.createObjectURL(blob);
//         link.setAttribute("href", url);
//         link.setAttribute("download", `${fileName}.csv`);
//         link.style.visibility = 'hidden';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//       } else {
//         TOAST_ERROR('Your browser does not support downloading files');
//       }
//     }
//   } catch (error) {
//     TOAST_ERROR(error);
//   }
// };

// const ExportToExcel = (data, fileName) => {
//   try {
//     const columns = Object.keys(data?.users?.[0])?.map(item => item?.replace('_', ' ')?.toUpperCase());
//     const columns1 = Object.keys(data?.users?.[0]);

//     const wb = new ExcelJS.Workbook();
//     const ws = wb.addWorksheet('Sheet 1');

//     ws.addRow(columns);

//     data.forEach(item => {
//       const row = [];
//       columns1.forEach(column => {
//         row.push(item[column]);
//       });
//       ws.addRow(row);
//     });

//     wb.xlsx.writeBuffer().then(buffer => {
//       const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//       const link = document.createElement('a');
//       link.href = window.URL.createObjectURL(blob);
//       link.setAttribute('download', `${fileName}.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     });
//   } catch (error) {
//     TOAST_ERROR(error);
//   }
// };

// const ExportToPdf = (data, fileName, header) => {
// console.log('data :', data);
// console.log('fileName :', fileName);
//   try {
//     const doc = new jsPDF();
//     doc.setFontSize(18);
//     doc.text(header, 14, 10);
//     doc.setLineWidth(0.5);
//     doc.line(14, 12, 196, 12);
//     doc.setFontSize(18);

//     const columns = Object.keys(data?.users?.[0])?.map(item => item?.replace('_', ' ')?.toUpperCase());
//     console.log('columns :', columns);
//     const tableData = data?.users?.map(item => Object.values(item));
//     console.log('tableData :', tableData);
//     doc.autoTable(columns, tableData);
//     doc.save(`${fileName}.pdf`);
//   } catch (error) {
//   console.log('error :', error);
//     TOAST_ERROR(error);
//   }
// };


const ExportToCSV = (data, fileName) => {
  try {
    let csvContent = '';
    if (data?.users && Array.isArray(data.users) && data.users.length > 0) {
      // Get headers from first object
      const headers = Object.keys(data.users[0]);
      // Add headers row
      csvContent += headers.join(",") + "\n";
      // Add data rows
      csvContent += data.users
        .map(row => 
          headers.map(header => {
            const value = row[header] ?? '';
            // Handle values with commas by wrapping in quotes
            return typeof value === 'string' && value.includes(',')
              ? `"${value}"`
              : value;
          }).join(",")
        )
        .join("\n");
      
      const blob = new Blob([csvContent], { type: 'text/csv' });
      
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, `${fileName}.csv`);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", `${fileName}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        } else {
          TOAST_ERROR('Your browser does not support downloading files');
        }
      }
    } else {
      TOAST_ERROR('No valid user data provided');
    }
  } catch (error) {
    TOAST_ERROR(error);
  }
};

const ExportToExcel = (data, fileName) => {
  try {
    if (!data?.users || !Array.isArray(data.users) || data.users.length === 0) {
      throw new Error('No valid user data provided');
    }

    const columns = Object.keys(data.users[0]).map(item => 
      item.replace('_', ' ').toUpperCase()
    );
    const columnKeys = Object.keys(data.users[0]);

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Sheet 1');

    // Add header row
    ws.addRow(columns);

    // Add data rows
    data.users.forEach(item => {
      const row = columnKeys.map(column => item[column] ?? '');
      ws.addRow(row);
    });

    // Generate and download
    return wb.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', `${fileName}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  } catch (error) {
    TOAST_ERROR(error);
  }
};

// Original ExportToPdf (unchanged as it was correct)
const ExportToPdf = (data, fileName, header) => {
  try {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text(header, 14, 10);
    doc.setLineWidth(0.5);
    doc.line(14, 12, 196, 12);
    doc.setFontSize(18);

    const columns = Object.keys(data?.users?.[0])?.map(item => 
      item.replace('_', ' ').toUpperCase()
    );
    const tableData = data?.users?.map(item => Object.values(item));
    doc.autoTable(columns, tableData);
    doc.save(`${fileName}.pdf`);
  } catch (error) {
    TOAST_ERROR(error);
  }
};
const handleEmailClick = (email) => {
  window.location.href = `mailto:${email}`;
};

const handleNoDataFound = (page) => {
  return (
    <div className='mt-4'><h1 className='fs-23 text-center m-3'>{page} not found</h1></div>
  )
};
export {
  capitalizeWords,
  inputHandlerMaxLength,
  SWIT_LOGOUT,
  validateLessThanMax,
  isActive,
  formatDate,
  formatDateLocalToUtc,
  convert12hrTo24hr,
  convert24hrTo12hr,
  convertToBase64,
  TEXT_WITH_NOT_START_SPACE_VALIDATION,
  TOAST_SUCCESS,
  SWIT_SUCCESS,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
  TOAST_INFO,
  TOAST_ERROR,
  TOAST_WARNING,
  MOBILE_VALIDATION,
  EMAIL_VALIDATION,
  PASSWORD_VALIDATION,
  CONFIRM_PASSWORD_VALIDATION,
  NUMBER_VALIDATION,
  TEXT_VALIDATION,
  TEXT_WITH_SPACE_VALIDATION,
  TEXT_NUMBERS_VALIDATION,
  TEXTAEREA_NUMBERS_VALIDATION,
  isOnlyNumber,
  isOnlyNumberMaxLength,
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleEmailClick,
  handleNoDataFound,
  convertToPNG,
};
